module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    staticStyle: {
      "margin-top": "5em"
    },
    attrs: {
      "id": "pAAu"
    }
  }, [_vm._v("\n\t\t\t\t\tThis book is dedicated to The Wellness Council"), _c('br'), _vm._v("\n\t\t\t\t\tfor SC members, supporters, and volunteers. Past,"), _c('br'), _vm._v("\n\t\t\t\t\tpresent, and future. Thank you for everything!")]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pAb7"
    }
  }, [_vm._v("\n\t\t\t\t\tOur hope is that this book will help inspire a new"), _c('br'), _vm._v("\n\t\t\t\t\tgeneration to make themselves healthy and the"), _c('br'), _vm._v("\n\t\t\t\t\tworld around them a better place to live.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b0e4812","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication1.vue
// module id = 63
// module chunks = 0